export const BULKUPDATE_VENUES= 'BULKUPDATE_VENUES'
export const BULKUPDATE_VENUES_SUCCESS= 'BULKUPDATE_VENUES_SUCCESS'
export const BULKUPDATE_VENUES_ERROR='BULKUPDATE_VENUES_ERROR'

export const BulkUpdateVenues= (data) => ({
    type: BULKUPDATE_VENUES,
    payload: data
})